export default "__VITE_ASSET__0df19a81__"